import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/educacao/receitas/listar'


function ListarReceitasEducacaoScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Receitas da Secretaria Municipal de Educação" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarReceitasEducacaoScreen;